import { type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor — wird vom Bootstrap importiert, OHNE den Barrel
 * eager zu laden. Der Barrel zieht TrainingPage/LessonPage inkl. sämtlicher
 * Markdown-Lektionen und react-markdown/remark-gfm (~430 KB) — die Seiten
 * kommen über die Lazy-Routes in App.tsx.
 */
const manifest: SkillManifest = {
  key: 'training',
  name: 'Schulungsplattform',
  description:
    'Strukturierte Lernpfade mit interaktiven Übungen und Fortschritts-Tracking. ' +
    'Im Hilfe-Center unter „Schulung".',
  category: 'ui',
  version: '0.1.0',
  requiredPermissions: [],
  enabledByDefault: true,
};

export const trainingSkill: FrontendSkill = {
  manifest,
  slots: {},
};
